export const extractFirstUrl = (value = '') => {
  const match = String(value).trim().match(/https?:\/\/[^\s]+/i);
  return match ? match[0].replace(/[),.;،]+$/g, '') : '';
};

export const normalizeProfileLink = (value = '') => {
  const normalized = String(value).trim();
  const embeddedUrl = extractFirstUrl(normalized);

  if (embeddedUrl) return embeddedUrl;
  if (/^(mailto:|tel:)/i.test(normalized)) return normalized;
  return normalized ? `https://${normalized}` : '';
};

export const isWhatsAppLink = (value = '') => (
  /^https?:\/\/(?:[^/]+\.)?(?:wa\.me|whatsapp\.com)(?:\/|$)/i.test(value)
);

const SOCIAL_HOSTS = [
  'behance.net',
  'discord.com',
  'discord.gg',
  'dribbble.com',
  'facebook.com',
  'github.com',
  'gitlab.com',
  'instagram.com',
  'linkedin.com',
  'medium.com',
  'pinterest.com',
  'quora.com',
  'reddit.com',
  'snapchat.com',
  'soundcloud.com',
  'spotify.com',
  't.me',
  'telegram.me',
  'threads.net',
  'tiktok.com',
  'tumblr.com',
  'twitch.tv',
  'twitter.com',
  'vimeo.com',
  'vk.com',
  'wa.me',
  'whatsapp.com',
  'x.com',
  'youtu.be',
  'youtube.com'
];

export const isSocialMediaLink = (value = '') => {
  const normalized = normalizeProfileLink(value);
  if (!normalized) return true;

  try {
    const host = new URL(normalized).hostname.toLowerCase().replace(/^www\./, '');
    return SOCIAL_HOSTS.some((socialHost) => (
      host === socialHost || host.endsWith(`.${socialHost}`)
    ));
  } catch (error) {
    return false;
  }
};

export const normalizeWhatsAppLink = (value = '') => {
  const normalized = String(value).trim();
  const embeddedUrl = extractFirstUrl(normalized);

  if (embeddedUrl) return embeddedUrl;
  return normalized ? `https://api.whatsapp.com/send?phone=${normalized}` : '';
};

export const isValidWhatsAppInput = (value = '') => {
  const normalized = String(value).trim();
  if (!normalized) return true;

  const embeddedUrl = extractFirstUrl(normalized);
  if (embeddedUrl) return isWhatsAppLink(embeddedUrl);

  return /^[1-9][0-9]{10,}$/.test(normalized);
};
